import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: { 
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0)
    },
   },
   title: {
    margin: theme.spacing(1),
    color: "primary"
  },
  drawer :{
  },
  drawerPaper: {
    [theme.breakpoints.up('md')]: {
      width: "35%",
      flexShrink: 0,
    },
    [theme.breakpoints.down('md')]: {
      width: "100%",
      flexShrink: 0,
    },
  },
}));